import React from "react";
import { useEffect, useRef, useState } from "react";
import { ineVerificate } from "../../api/ineVerificate";
import folder from '../../assets/folder.svg';
import file from '../../assets/file.svg';
import shield from '../../assets/shield.svg';
import scanner from '../../assets/scanner.svg';
import Modal from 'react-bootstrap/Modal';
import './style.css';

function Pantalla26() {

    const isRunned = useRef(false);
    const [dateReco, setDateReco] = useState("");
    const [strStatus, setStrStatus] = useState("");
    const [strOperation, setStrOperation] = useState("");
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState('');

    const handleClose = () => {
        setShow(false);
    }

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            const objModelIncode = {

                interviewId: localStorage.getItem("interviewIdINE"),
                tokenIncode: localStorage.getItem("tokenIncodeINE"),
            }

            const responseVerificate = await ineVerificate(objModelIncode);

            if (responseVerificate.status === 200) {

                setDateReco(responseVerificate.dateT);

            } else {

                setShow(true);
                setShowStatus(responseVerificate.status);
                setShowMessage(responseVerificate.message);
            }

            setStrOperation("Verificación de Identificación Personal");
            setStrStatus("Verificado");

        }

        createSession();

    }, []);


    return (
        <>
            <div className='containerInfo_P2'>
                <div className='containerIdent_P2'>
                    <div className='txtOp_P2'>Operación/Operation</div>
                    <div className='txtVer_P2'>{strOperation}</div>
                    <div className='txtCpv_P2'>Estatus/Status</div>
                    <div className='txtVer_P2'>{strStatus}</div>
                    <div className='txtOp_P2'>Fecha/Date</div>
                    <div className='txtVer_P2'>{dateReco}</div>
                </div>
                <div className='containerDoc_P2'>
                    <div className='txtReq_P2'>En esta operación se realizó:</div>
                </div>
                <div className='container_data_operation'>
                    <img src={file} align="left" className='imgFol_P2' />
                    <div className='txtDocReq_P2'>Número de Identificación Nacional</div>
                    <p className='txtIdenOf_P2_6'>Verificación del Número de Identificación Nacional.</p>

                    <img src={shield} align="left" className='imgFol_P2' />
                    <div className='txtDocReq_P2'>Política de Privacidad</div>
                    <p className='txtIdenOf_P2_6'>Aceptación de recopilación y uso final de datos.</p>

                    <img src={folder} align="left" className='imgFol_P2' />
                    <div className='txtDocReq_P2'>Documento de Identificación</div>
                    <p className='txtIdenOf_P2_6'>Verificación de Documento Oficial con fotografía.</p>

                    <img src={scanner} align="left" className='imgFol_P2' />
                    <div className='txtDocReq_P2'>Reconocimiento Facial</div>
                    <p className='txtIdenOf_P2_6'>Comparación contra Documento Oficial.</p>
                </div>
            </div>

            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    )
}
export default Pantalla26
